import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supa } from '../components/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { useAuth } from '../components/AuthProvider';

function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/home');
    }
  }
  , [user]);

  return(
  <div className='flex w-screen bg-zinc-900 h-screen flex-col lg:flex-row items-center justify-between overflow-hidden'>
    {/* Sezione animazione RNP - Hidden su mobile, visibile su desktop */}
    <div className='hidden lg:flex w-full lg:w-3/5 h-32 lg:h-full items-center shadow-xl justify-between flex-col py-8'>
      <p className='invisible'>ciao</p>
      <div className="gas ne flex flex-row">
        <h2 className="symbol transform -scale-x-100 text-flicker-in-glow1">R</h2>
        <h2 className="symbol text-flicker-in-glow2">N</h2>
        <h2 className="symbol flex items-center text-flicker-in-glow3">P</h2>
      </div>
      <div className="gas ne focus-in-contract flex flex-col pb-2">
        <h2 className='symbol2'>powered by GioPz</h2>
      </div>
    </div>

    {/* Mobile Header - Versione compatta solo su mobile */}
    <div className='lg:hidden w-full flex flex-col items-center justify-center py-8 px-4'>
      <div className="gas ne flex flex-row">
        <h2 className="symbol transform -scale-x-100 text-flicker-in-glow1 !text-6xl">R</h2>
        <h2 className="symbol text-flicker-in-glow2 !text-6xl">N</h2>
        <h2 className="symbol text-flicker-in-glow3 !text-6xl">P</h2>
      </div>
    </div>
    
    {/* Sezione Form Login - Responsive */}
    <div className='w-full lg:w-2/5 flex-1 lg:h-full flex flex-col bg-[#FFE037] items-center justify-center px-6 py-8 lg:py-0'>
      <div className='w-full max-w-md flex flex-col items-center justify-center'>
        {/* Titolo */}
        <div className='mb-8 text-center'>
          <h1 className='text-3xl lg:text-4xl font-bold text-zinc-900 mb-2'>
            Benvenuto
          </h1>
          <p className='text-zinc-700 text-sm lg:text-base'>
            Accedi per continuare
          </p>
        </div>

        {/* Auth Form con stili custom */}
        <div className='w-full'>
          <Auth
            supabaseClient={supa}
            appearance={{
              style: {
                button: {
                  background: "rgb(24,24,27)",
                  borderWidth: 0,
                  height: 48,
                  borderRadius: 12,
                  color: "#FFE037",
                  marginTop: 24,
                  fontSize: 16,
                  fontWeight: 600,
                  transition: 'all 0.2s',
                  cursor: 'pointer',
                },
                input: {
                  height: 48,
                  borderRadius: 12,
                  borderWidth: 2,
                  borderColor: 'transparent',
                  background: "white",
                  color: "rgb(24,24,27)",
                  padding: '12px 16px',
                  fontSize: 16,
                  transition: 'all 0.2s',
                  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
                },
                label: {
                  color: "rgb(24,24,27)",
                  paddingBottom: 8,
                  fontSize: 14,
                  fontWeight: 600,
                },
                anchor: {
                  color: "rgb(24,24,27)",
                  fontWeight: 500,
                  fontSize: 14,
                  textDecoration: 'underline',
                },
                message: {
                  padding: 12,
                  borderRadius: 8,
                  marginTop: 16,
                  fontSize: 14,
                },
                container: {
                  width: '100%',
                },
              },
              className: {
                button: 'hover:bg-zinc-800 active:scale-95',
                input: 'focus:border-zinc-900 focus:ring-2 focus:ring-zinc-900 focus:ring-offset-2',
              }
            }}
            providers={[]}
            localization={{
              variables: {
                sign_in: {
                  email_label: 'Email',
                  password_label: 'Password',
                  button_label: 'Accedi',
                  loading_button_label: 'Accesso in corso...',
                  link_text: 'Hai già un account? Accedi'
                },
                sign_up: {
                  email_label: 'Email',
                  password_label: 'Password',
                  button_label: 'Registrati',
                  loading_button_label: 'Registrazione...',
                  link_text: 'Non hai un account? Registrati'
                },
                forgotten_password: {
                  link_text: 'Password dimenticata?',
                  button_label: 'Invia istruzioni',
                  loading_button_label: 'Invio...',
                }
              }
            }}
          />
        </div>

        {/* Footer - Solo su mobile */}
        <div className='lg:hidden mt-8 text-center'>
          <p className='text-sm text-zinc-700 font-medium'>powered by GioPz</p>
        </div>
      </div>
    </div>
  </div>
  );

}

export default Login;
